import {createSlice} from '@reduxjs/toolkit';

const DefaultDayCount = 200;
const licenseProps = {
    'norms-demo26-1w': {
        title: 'Демо 1неделя',
        alertRules: {maxCount: 40, maxDays: 1}
    },
    'norms-start26-12m': {
        title: 'Старт 12мес',
        alertRules: {maxCount: 1000, maxDays: 7}
    },
    'norms-start26-1m': {
        title: 'Старт 1мес',
        alertRules: {maxCount: 100, maxDays: 3}
    },
    'norms-start26-12m-promo': {
        title: 'Старт (Промо) 12мес',
        alertRules: {maxCount: 1000, maxDays: 7}
    },
    'norms-start26-1m-promo': {
        title: 'Старт (Промо) 1мес',
        alertRules: {maxCount: 100, maxDays: 3}
    },
    'norms-start26-1w-promo': {
        title: 'Старт (Промо) 1неделя',
        alertRules: {maxCount: 40, maxDays: 1}
    },
    'norms-opt26-12m': {
        title: 'Оптимум 12мес',
        alertRules: {maxCount: 2500, maxDays: 14}
    },
    'norms-opt26-1m': {
        title: 'Оптимум 1мес',
        alertRules: {maxCount: 200, maxDays: 3}
    },
    'norms-opt26-12m-promo': {
        title: 'Оптимум (Промо) 12мес',
        alertRules: {maxCount: 2500, maxDays: 14}
    },
    'norms-max26-12m': {
        title: 'Максимум 12мес',
        alertRules: {maxCount: 4200, maxDays: 14}
    },
    'norms-max26-12m-promo': {
        title: 'Максимум (Промо) 12мес',
        alertRules: {maxCount: 4200, maxDays: 14}
    },
    'norms-demo-1w': {
        title: 'Демо 1неделя',
        alertRules: {maxCount: 100, maxDays: 1}
    },
    'norms-start-12m': {
        title: 'Старт 12мес',
        alertRules: {maxCount: 1800, maxDays: 7}
    },
    'norms-start-1m': {
        title: 'Старт 1мес',
        alertRules: {maxCount: 200, maxDays: 3}
    },
    'norms-opt-12m': {
        title: 'Оптимум 12мес',
        alertRules: {maxCount: 4200, maxDays: 14}
    },
    'norms-max-12m': {
        title: 'Максимум 12мес',
        alertRules: {maxCount: 8400, maxDays: 14}
    },
    'norms-start-12m-promo': {
        title: 'Старт (Промо) 12мес',
        alertRules: {maxCount: 1000, maxDays: 7}
    },
    'norms-start-1m-promo': {
        title: 'Старт (Промо) 1мес',
        alertRules: {maxCount: 100, maxDays: 3}
    },
    'norms-opt-12m-promo': {
        title: 'Оптимум (Промо) 12мес',
        alertRules: {maxCount: 2500, maxDays: 14}
    },
    'norms-max-12m-promo': {
        title: 'Максимум (Промо) 12мес',
        alertRules: {maxCount: 4200, maxDays: 14}
    }
}
export const licenseSlice = createSlice({
    name: 'licenseReducer',
    initialState: {
        count: 0,
        dayCount: 0,
        dateBegin: '',
        dateEnd: '',
        name: '',
        title: '',
        licenseEnded: false,
        licenseEnding: false,
        licenseCountEnded: false,
        licenseDayCountEnded: false,
        daysLeft: 0,
        dayCountTime: '',
        openSessionsAlert: false,
        openLicenseEndedTimeAlert: false,
        openLicenseEndingAlert: false,
        openLicenseEndedClicksAlert: false,
        serverIsNotRespondingAlert: false,
        serverIsNotRespondingAlertTime: 0,
        openDayClicksEndedAlert: false,
        openDayClicksEndingAlert: false,
        errorMessage:{
            isOpen:false,
            messageCode:""
        },
    },
    reducers: {
        setLicense: (state, action) => {
            state.count = action.payload.data.count;
            state.dayCount = action.payload.data.dayCount;
            state.dateBegin = action.payload.data.dateBegin;
            state.dateEnd = action.payload.data.dateEnd;
            state.name = action.payload.data.name;
            state.dayCountTime = action.payload.data.dayCountTime;

            state.licenseEnded = false;
            state.licenseEnding = false;
            state.licenseCountEnded = false;
            state.licenseDayCountEnded = false;
            state.openDayClicksEndedAlert = false;

            const today = new Date()
            state.daysLeft = Math.ceil(((new Date(state.dateEnd)) - today) / (1000 * 60 * 60 * 24)) || 0

            if (state.daysLeft < 0) {
                state.daysLeft = 0
            }
            if (state.name && licenseProps?.[state.name]?.title) {
                state.title = licenseProps[state.name].title;
            }
            if (action.payload.code !== 2 && action.payload.code !== 3) {
                const license = state.name
                    ? licenseProps?.[state.name]
                    : null;

                const rules = license?.alertRules;
                if (rules && (state.count < rules.maxCount || state.daysLeft < rules.maxDays)) {
                    state.openLicenseEndingAlert = true;
                    state.licenseEnding = true;
                }
            }

            if (action.payload.code === 2 || action.payload.code === 3) {
                state.licenseEnding = false
                if (state.daysLeft === 0) {
                    state.licenseEnded = true
                    state.openLicenseEndedTimeAlert = true
                } else if (state.count === 0) {
                    state.licenseCountEnded = true;
                    state.openLicenseEndedClicksAlert = true
                }
            } else {
                state.openLicenseEndedClicksAlert = false
                state.openLicenseEndedTimeAlert = false
                state.licenseEnded = false
            }

            if (state.count > 0 && state.daysLeft > 0) {
                if (state.dayCount === 0) {
                    state.licenseDayCountEnded = true;
                    state.openDayClicksEndedAlert = true;
                } else if (state.dayCount < DefaultDayCount * 0.1) {
                    state.openDayClicksEndingAlert = true;
                }
            }
        },
        setCount: (state, action) => {
            state.count = action.payload;
        },
        setDayCount: (state, action) => {
            if (action.payload !== undefined) {
                const alreadyEnding = state.dayCount < DefaultDayCount * 0.1;

                state.dayCount = action.payload;

                if(state.dayCount === 0) {
                    state.licenseDayCountEnded = true;
                    state.openDayClicksEndedAlert = true;
                }
                if (!alreadyEnding && state.dayCount < DefaultDayCount * 0.1) {
                    state.openDayClicksEndingAlert = true;
                }
            }
        },
        setOpenLicenseEndingAlert: (state, action) => {
            state.openLicenseEndingAlert = action.payload;
        },
        setOpenLicenseEndedClicksAlert: (state, action) => {
            state.openLicenseEndedClicksAlert = action.payload;
        },
        setOpenDayClicksEndedAlert: (state, action) => {
            state.openDayClicksEndedAlert = action.payload;
        },
        setOpenDayClicksEndingAlert: (state, action) => {
            state.openDayClicksEndingAlert = action.payload;
        },
        setOpenLicenseEndedTimeAlert: (state, action) => {
            state.openLicenseEndedTimeAlert = action.payload;
        },
        setOpenTooManySessions: (state, action) => {
            state.openSessionsAlert = action.payload;
        },
        setCustomAlertMessage:(state, action) => {
            state.errorMessage = action.payload;
        },
        setServerIsNotRespondingAlert: (state, action) => {
            const newValue = action.payload;

            if (newValue !== state.serverIsNotRespondingAlert) {
                const currentSeconds = (new Date().getTime()) / 1000;
                const elapsedSeconds = currentSeconds - state.serverIsNotRespondingAlertTime;

                if (!newValue) {
                    state.serverIsNotRespondingAlert = newValue;
                    state.serverIsNotRespondingAlertTime = currentSeconds;
                } else if (elapsedSeconds >= 10) {
                    state.serverIsNotRespondingAlert = newValue;
                    state.serverIsNotRespondingAlertTime = currentSeconds;
                }
            }
        },
    },
});

export const {
    setLicense,
    setCount,
    setDayCount,
    setOpenLicenseEndingAlert,
    setOpenLicenseEndedClicksAlert,
    setOpenDayClicksEndedAlert,
    setOpenDayClicksEndingAlert,
    setOpenLicenseEndedTimeAlert,
    setOpenTooManySessions,
    setServerIsNotRespondingAlert,
    setCustomAlertMessage
} = licenseSlice.actions;

export default licenseSlice.reducer;
